export const COMPLEX_FILTER_KEY = "_json";
export const SEARCH_WORD_KEY = "_searchword";

/**
 * Transformiert MRT-Filter in zwei Teile:
 * - simple: direkt auflösbare Filter (ein einzelnes Feld)
 * - complex: kombinierte Bedingungen (z.B. mehrere accessorKeys)
 */
export const transformFilters = (filters = []) => {
  const simple = {};
  const complexOrs = [];

  if (!Array.isArray(filters)) {
    return { simple, complex: null };
  }

  filters.forEach((curr) => {
    const accessorKeys = curr.accessorKeys || [];
    const operator =
      curr.operator ||
      (curr.column?.filterVariant === "select" ? "eq" : "contains");
    let value = curr.value;

    if (!value) {
      return;
    }

    // check if filterVariante is date convert local datetime to MYSQL date string
    if (curr.column?.filterVariant === "date") {
      console.log(
        "filterVariante datetime",
        value,
        value.toISOString(),
        value.toISOString().split("T")[0]
      );
      value = value.toISOString().split("T")[0];
    }

    if (accessorKeys.length > 1) {
      const orGroup = accessorKeys.reduce((acc, key) => {
        if (key) {
          acc[key] = { [operator]: value };
        }
        return acc;
      }, {});

      if (Object.keys(orGroup).length > 0) {
        complexOrs.push({ $or: orGroup });
      }

      return;
    }

    const field = accessorKeys[0] || curr.id || curr.column?.accessorKey;

    if (!field) {
      return;
    }

    simple[field] = value;
  });

  const complex = complexOrs.length > 0 ? { $and: complexOrs } : null;

  return { simple, complex };
};

/**
 * Transformiert die Sortierdaten in ein standardisiertes Format.
 * Beispiel:
 * Input: [
 *   { id: "name", desc: false },
 *   { id: "date", desc: true }
 * ]
 * Output: [
 *   { field: "name", order: "asc" },
 *   { field: "date", order: "desc" }
 * ]
 *
 * @param {Array} sort - Die Sortierdaten.
 * @returns {Array} - Das transformierte Sortierobjekt.
 */
export const transformSort = (sort) => {
  return sort?.map((s) => ({
    field: s.field || s.id,
    order: s.order || s.desc ? "desc" : "asc",
  }));
};

export const applyFilterWithAccessorKeys = (filter, columns) => {
  return filter.map((f) => {
    const column = columns.find(
      (col) => col.accessorKey === f.id || col.header === f.id
    );
    if (column) {
      return {
        ...f,
        accessorKeys: column.accessorKeys || [column.accessorKey],
        column,
      };
    }
    return f;
  });
};

export const applySortingWithAccessorKeys = (sort, columns) => {
  return sort.flatMap((s) => {
    const column = columns.find(
      (col) =>
        col.accessorKey === s.id || col.header === s.id || col.id === s.id
    );
    console.log({ sort_column: column });

    if (column) {
      const keys = column.accessorKeys || [column.accessorKey];
      return keys.map((key) => ({ id: key, desc: s.desc }));
    }

    return s;
  });
};
